import React, {useState, useEffect} from "react";
import Zoom from '@mui/material/Zoom';
import axios from "axios";
import "./ContactForm.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from "./LanguageContext";
import { siteContact } from "./siteContact";

function ContactForm(props) {
  const { t } = useLanguage();
    const [contactForm, setContactForm] = useState({
    title: "place",
    email: props.userData?.email ?? "",
        content: ""
    });
    const [showContactForm, setShowContactForm] = useState(true);
    const [errorText, setErrorText] = useState({
        color: "",
        content: ""
    });
    const maxFormContent = 1000;
    // const [recaptcha, setRecaptcha] = useState(false);
    // const key = process.env.REACT_APP_RECAPTCHA_KEY;
    // const [showEmailField, setShowEmailField] = useState(true);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        })
      }, []);

    function handleChange(event) {
        // const newValue = event.target.value;
        // const inputName = event.target.name;
        const {name, value} = event.target;

        setContactForm(prevValue =>{
            return{
                ...prevValue,
                [name]: value
            }
        });
      }

      function submitForm(){
        if (isValid() === false){
            return;
        };

        // console.log("Form submitted: ");
        // console.log(contactForm);

        axios.post(process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_SEND_FORM, {
            email: contactForm.email,
          title: t({ place: "contactSubjectPlace", issue: "contactSubjectIssue", other: "contactSubjectOther" }[contactForm.title]),
            content: contactForm.content
        }).then(response =>{
            responseSubmitForm(response);
            // toast("Formularz wysłany poprawnie");
        }).catch(err =>{
            // console.log(err);
            responseSubmitForm(err.response);
            // toast("Błąd formularza!");
        });

        setErrorText({ color: "black", content: "..."});
        setShowContactForm(false);
      }

      function responseSubmitForm(response){
        if (response === undefined || response.status === undefined){
            return;
        };

        switch (response.status){
            case 200:
                setErrorText({ color: "green", content: t("contactFormSuccess")});
                break;
                default:
                    setErrorText({ color: "red", content: t("contactFormFailure")});
                    break;
        }
        
      }

      function isValid(){
        if (contactForm.content.length > maxFormContent){
            setErrorText({ color: "red", content: "Formularz nie może przekraczać " + maxFormContent + 
            " znaków. Teraz ma " + contactForm.content.length + " znaków."})
            return false;
        };

        if (contactForm.content.length <= 0){
            setErrorText({ color: "red", content: t("contactFormEmpty")})
            return false;
        }

        return true;
      }

      // function loginOnClick(){
      //   props.changeState("UserLogin");
      // }

    //   function handleRecaptcha(){
    //     setRecaptcha(!recaptcha);
    // };

  return (
    <main className="contact-page">
      <header className="contact-heading">
        <p>{t("contactKicker")}</p>
        <h1>{t("contact")}</h1>
        <span>{t("contactIntro")}</span>
      </header>
      <div className="contact-layout">
        <section className="contact-details"><h2>{t("contactDetails")}</h2>
          <div className="contact-detail"><FontAwesomeIcon icon={faEnvelope} /><span><strong>{t("contactEmail")}</strong><a className="contact-email-value" href={`mailto:${siteContact.email}`}>{siteContact.email}</a></span></div>
          <div className="contact-detail"><FontAwesomeIcon icon={faLocationDot} /><span><strong>{t("contactOffice")}</strong>{siteContact.addressLine}<br />{siteContact.postalCity}<a className="contact-map-link" href={siteContact.mapUrl} target="_blank" rel="noreferrer">{t("contactMap")}</a></span></div>
          <div className="contact-detail"><FontAwesomeIcon icon={faBuilding} /><span><strong>{t("contactTaxId")}</strong>NIP: {siteContact.taxId}</span></div>
        </section>
        <section className="contact-form-panel"><h2>{t("contactFormTitle")}</h2><p>{t("contactFormIntro")}</p>

        {props.userLogged === false ?
    <div className="contactForm-text">
        {/* <p>Aby się z nami skontaktować <a href="#" pointerEvents="none" onClick={loginOnClick}>zaloguj się</a>. */}
        {/* <p>Aby wyświetlić formularz kontaktowy <a href="#" pointerEvents="none" onClick={loginOnClick}>zaloguj się</a>. */}
        <p>{t("contactLoginPrompt")}</p>
        <Link className="contact-login-link" to={"/logowanie"}>{t("contactLogin")}</Link>
    </div> : props.userData.active === false ?
    <div className="contactForm-text">
        <p>{t("contactVerifyPrompt")}</p>
        </div> : showContactForm === false ? null :
    <div>
<form className="create-comment contactForm">
      <input
      className="contactForm-email"
            name="email"
            onChange={handleChange}
            value={contactForm.email}
            placeholder={props.userData.email}
            disabled
          />
          <hr></hr>

          {/* <input
            name="title"
            onChange={handleChange}
            value={contactForm.title}
            placeholder="tytuł"
          /> */}
          <label>{t("contactSubject")}</label>
          <select name="title" onChange={handleChange} value={contactForm.title}>
            <option value="place">{t("contactSubjectPlace")}</option><option value="issue">{t("contactSubjectIssue")}</option><option value="other">{t("contactSubjectOther")}</option>
          </select>

          <hr></hr>

          {/* <div className="recaptcha">
            <ReCAPTCHA sitekey={key} onChange={handleRecaptcha} />
            </div> */}

        <textarea
          name="content"
          onChange={handleChange}
          value={contactForm.content}
          placeholder={t("contactMessagePlaceholder")}
        />
        <Zoom in={true}>
        {/* <Button variant="contained" onClick={submitForm}> */}
          {/* <AddIcon /> */}
          
          {/* Wyślij */}
        {/* </Button> */}
        <button type="button" className="btn btn-primary" onClick={submitForm}>{t("contactSend")}</button>
        </Zoom>
        <p className="contact-form-error" style={{color: errorText.color}}>{errorText.content}</p>
      </form>
        </div>
    }

    {/* <div className="contact-form-error">
    <p style={{color: errorText.color}}>{errorText.content}</p>
    </div> */}

        </section>
      </div>
    </main>
  );
}

export default ContactForm;